function initParallax() {
  jarallax(document.querySelectorAll(".has-parallax-feed .gh-card"), {
    speed: 0.8,
  });
}

(function () {
  if (document.body.classList.contains("tag-hash-video")) {
    const featuredVideo = document.querySelector(".featured-video");
    const ytEmbed = document.querySelector(".kg-embed-card");
    featuredVideo.appendChild(ytEmbed);
  }
})();

// (function () {
//   const codeBlocks = document.querySelectorAll("code");
//   Array.from(codeBlocks).forEach(codeBlock => {
//     const copyBtn = document.createElement('button');
//     copyBtn.textContent = "Copy";
//     copyBtn.classList.add("copy-btn");
//     copyBtn.addEventListener("click", event => {
//       const text = codeBlock.textContent;
//       navigator.clipboard.writeText(text).then(() => {
//         event.currentTarget.classList.add("copy-success");
//         setTimeout(() => {
//           event.currentTarget.classList.remove("copy-success");
//         }, 1800);
//       });
//     });
//     codeBlock.appendChild(copyBtn);
//   });
// })();

(function () {
  if (!document.body.classList.contains("has-background-about")) return;

  const about = document.querySelector(".gh-about");
  if (!about) return;

  const image = about.querySelector(".gh-about-image");

  if (!image.naturalWidth) {
    imagesLoaded(image, function () {
      about.style.setProperty(
        "--about-height",
        (image.clientWidth * image.naturalHeight) / image.naturalWidth + "px"
      );
    });
  }
})();

(function () {
  initParallax();
})();

(function () {
  const toggle = document.querySelector("[data-toggle-comments]");
  if (!toggle) return;

  toggle.addEventListener("click", function () {
    document.body.classList.toggle("comments-opened");
  });
})();

(function () {
  const element = document.querySelector(".gh-article-excerpt");
  if (!element) return;

  let text = element.textContent;
  const emojiRE = /\p{EPres}|\p{ExtPict}/gu;

  const emojis = text.match(emojiRE);
  if (!emojis) return;

  emojis.forEach(function (emoji) {
    text = text.replace(emoji, `<span class="emoji">${emoji}</span>`);
  });

  element.innerHTML = text;
})();

(function () {
  pagination(true, initParallax);
})();
